import { phoneInputHandler } from '../../../../templates/main/phoneInputHandler';
import { waveEffect } from '../../../../templates/main/waveEffect';

export const Form = {
    props: ['productId', 'productName', 'downloadContext'],
    data: () => ({
        formData: {form_text_21: '', form_text_25: ''},
        spinner: false,
        submited: false,
        url_buklet: '',
        countdown: 30,
        intervalId: null,
        phoneError: false,
        errorMessage: '',
    }),
    computed: {
        isEngineDownload() { return this.downloadContext === 'engine'; },
        formTitle() { return this.isEngineDownload ? 'Скачать коммерческое предложение' : 'Скачать буклет'; },
        fileLabel() { return this.isEngineDownload ? 'Скачать КП' : 'Скачать буклет'; },
        buttonLabel() { return this.isEngineDownload ? 'Отправить и скачать КП' : 'Отправить и получить'; },
        downloadNotice() {
            return this.isEngineDownload
                ? 'После успешной отправки формы начнётся скачивание коммерческого предложения.'
                : 'После отправки формы буклет автоматически откроется в новой вкладке.';
        },
        storageKey() { return this.isEngineDownload ? 'lastFormEngineKpSubmitTime' : 'lastFormBukletSubmitTime'; },
    },
    methods: {
        send(e) {
            e.preventDefault();
            if (this.spinner || this.submited) return;
            const phone = this.formData.form_text_21.replace(/\D/g, '');
            this.phoneError = this.isEngineDownload ? phone.length < 10 || phone.length > 15 : phone.length < 9;
            if (this.phoneError) return;
            this.errorMessage = '';
            if (!window.BX || !BX.ajax || typeof BX.ajax.runComponentAction !== 'function') {
                this.errorMessage = 'Форма ещё загружается. Повторите отправку через несколько секунд.';
                return;
            }
            this.spinner = true;
            const data = {
                fields: {...this.formData, form_hidden_24: this.productId},
                form_id: 'buklet',
            };
            if (this.isEngineDownload) data.download_context = 'engine';
            return BX.ajax.runComponentAction('vv:forms', 'save', {
                mode: 'class', data: {data},
            }).then(response => {
                const result = response && response.data;
                if (!result || result.status !== 'success') {
                    throw new Error(result && result.message || 'Не удалось отправить заявку. Попробуйте ещё раз.');
                }
                if (!this.validDownloadUrl(result.data)) {
                    throw new Error('Не удалось получить файл. Обратитесь к менеджеру.');
                }
                this.url_buklet = result.data;
                this.submited = true;
                try { localStorage.setItem(this.storageKey, String(Date.now())); } catch (error) { /* Storage is optional. */ }
                this.startCountdown();
                if (this.isEngineDownload) {
                    const link = document.createElement('a');
                    link.href = result.data;
                    link.download = 'arslan-caterpillar-kp.pdf';
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                } else {
                    window.open(result.data, '_blank', 'noopener');
                }
            }).catch(error => {
                this.errorMessage = error && error.message || 'Ошибка соединения. Повторите отправку.';
            }).finally(() => { this.spinner = false; });
        },
        validDownloadUrl(value) {
            if (typeof value !== 'string' || /[\s\\]/.test(value)) return false;
            if (this.isEngineDownload) return /^\/upload\/[^\s\\]+$/.test(value);
            try {
                const url = new URL(value, window.location.origin);
                return url.origin === window.location.origin && url.pathname.startsWith('/upload/');
            } catch (error) { return false; }
        },
        handlePhoneInput() { this.phoneError = false; },
        startCountdown() {
            clearInterval(this.intervalId);
            this.intervalId = setInterval(() => {
                if (this.countdown > 1) this.countdown--;
                else this.clearForm();
            }, 1000);
        },
        clearForm() {
            try { localStorage.removeItem(this.storageKey); } catch (error) { /* Storage is optional. */ }
            clearInterval(this.intervalId);
            this.intervalId = null;
            this.formData = {form_text_21: '', form_text_25: ''};
            this.submited = false;
            this.url_buklet = '';
            this.countdown = 30;
            this.errorMessage = '';
            this.phoneError = false;
        },
    },
    mounted() {
        phoneInputHandler();
        waveEffect();
        let lastSubmitTime;
        try { lastSubmitTime = localStorage.getItem(this.storageKey); } catch (error) { /* Storage is optional. */ }
        const remaining = 30 - Math.floor((Date.now() - Number(lastSubmitTime)) / 1000);
        if (lastSubmitTime && remaining > 0 && remaining <= 30) {
            this.countdown = remaining;
            this.submited = true;
            this.startCountdown();
        }
    },
    beforeUnmount() { clearInterval(this.intervalId); },
    template: `<form action="" class="form" @submit="send">
        <h2 class="form__title">{{ formTitle }}</h2>
        <p v-if="isEngineDownload && productName" class="form__buklet-selection">{{ productName }}</p>
        <p v-if="!url_buklet" class="form__buklet-warn">{{ downloadNotice }}</p>
        <div class="form__single">
            <input type="text" name="form_text_25" autocomplete="name" :disabled="spinner || submited" class="form__field" v-model="formData.form_text_25" placeholder="Имя" aria-label="Имя">
            <input type="tel" name="form_text_21" autocomplete="tel" inputmode="tel" :disabled="spinner || submited" :class="['form__field', 'js-phone', {'form__field--error': phoneError}]" v-model="formData.form_text_21" @input="handlePhoneInput" placeholder="+7 (___) ___ __ __" aria-label="Телефон">
            <div v-if="phoneError" class="form__message-error" role="alert">Проверьте номер телефона</div>
            <div v-if="errorMessage" class="form__message-error" role="alert">{{ errorMessage }}</div>
            <div class="form__buklet-url" v-if="url_buklet">Если файл не открылся, <a download :href="url_buklet">{{ fileLabel }}</a></div>
            <div v-if="submited" class="form__disabled-time column">Форму можно повторно отправить через {{ countdown }} сек.</div>
            <div v-if="submited" class="form__submited" role="status"><span>Отправлено</span></div>
            <div class="form__sending" v-if="spinner"><div class="form__spinner"><div></div><div></div><div></div><div></div></div></div>
            <button v-if="!spinner && !submited" type="submit" class="form__submit btn">{{ buttonLabel }}</button>
        </div>
        <p class="form__conf">Нажимая кнопку «{{ buttonLabel }}», Вы соглашаетесь с <a target="_blank" rel="noopener" href="/conf/">Политикой конфиденциальности</a></p>
    </form>`,
};
